import { CLIENT_HOSTNAME } from 'common/utils/variables'
import fetch from '@/api/fetch.js'
import { THEME_LIST_2025 } from '@/config/theme.js'

const _fetch = (config = {}) => {
  return fetch({
    baseURL: CLIENT_HOSTNAME,
    ...config,
  }).then(response => {
    const { data, success, code, info } = response.data;
    if (!success) {
      return Promise.reject(new Error(`${code}: ${info}`));
    }
    return data
  })
}

export function addVisitorReadEvent(params) {
  return _fetch({
    url: '/visitorReadEventStatistic/addReadEvent',
    method: 'POST',
    data: params
  })
}